import { TimeMode } from './common'

export enum BookingUpgradeType {
  /** 0: 無 */
  None,
  /** 1: 升級必選 */
  Required,
}

export type ArrivalTimesPickerItem = {
  date: string
  discount: number
  meridiem: string
  promostart: string
  remain_count: number
  time: string
  selltime: string
}

export type ArrivalTimesPickerData = {
  arrivalTimes: Record<string, ArrivalTimesPickerItem[]>
  bestOffPeak: Record<string, boolean>
  sellDates: Record<string, SellDatesItem[]> | null
  start_day: string
  end_day: string
  time_mode: TimeMode
  timezone: string
  price: number
  symbol: string
  symbol_code: string
  currency_id?: number
  currency_symbol?: string
}

export type SellDatesItem = {
  time_range_name: string
  selltimes: { selltime: string }[]
}

export enum UpgradeAndAdditionalLimitFlag {
  /** 0: None */
  None,
  /** 1: only limit_min */
  OnlyLimitMin,
  /** 2: only limit_max */
  OnlyLimitMax,
  /** 3: both limit_min and limit_max */
  BothLimit,
}

export type UpgradeAndAdditionalQueryParams = {
  /** 預訂時間 格式為 2006-01-02 15:04:05 */
  arrival_time: string
  /** 數量, 可選人數需帶上人數，若不可選人數固定為 1 */
  count: number
  /** 揪團代碼 */
  group_code?: string
}

export type ProductUpgradeAdditionData = {
  additions?: ProductAdditionData[]
  allow_multi?: boolean
  currency_id?: number
  is_cust_num?: boolean
  limit_max?: number
  limit_min?: number
  max_sum?: number
  limit_flag: UpgradeAndAdditionalLimitFlag
  resource_use?: number
  stock?: number
  sub_item_max_sum?: number
  sub_item_min_sum?: number
  sub_items?: ProductSubItemData[]
  symbol?: string
  symbol_code?: string
  upgrade_mode?: number
  upgrades?: ProductUpgradeData[]
}

export type ProductAdditionData = {
  count?: number
  desc?: string
  discount?: number
  name?: string
  /** @deprecated, but retain this for compatibility */
  productID?: string
  product_id?: string
}

export type ProductSubItemData = {
  desc?: string
  free_qty?: number
  id?: string
  limit_max?: number
  limit_min?: number
  name?: string
  price?: number
  show_mode?: number
}

export type ProductUpgradeData = {
  bid?: number
  description?: string
  duration?: number
  is_required?: boolean
  is_sold_out?: boolean
  limit_min?: number
  name?: string
  price?: number
  resource_use?: number
  upgrade_id?: number
}

export enum BookingTimeSlotType {
  TIME_SLIDER,
  TIME_BLOCK,
}
